import React from 'react';
import { Bot } from 'lucide-react';
import CrawlerSettingsPanel from '../../components/CrawlerSettingsPanel';

const AdminCrawlers = () => (
  <div data-testid="admin-crawlers">
    <div className="mb-6">
      <h1 className="font-serif text-2xl text-cream font-semibold">SEO & Crawlers</h1>
      <p className="text-cream/30 text-sm mt-1">AI crawler management and robots.txt configuration</p>
    </div>
    <CrawlerSettingsPanel />
  </div>
);

export default AdminCrawlers;
